import React from "react";
import { useSelector } from "react-redux";
import { getAllMaterialSpecifications, getLineItemsHeader } from "store/features/materialSpecs/specs";
import { Paper, Table, TableBody, TableCell, TableContainer, TableHead } from "@material-ui/core";
import { MaterialSpecRow } from "pages/MaterialSpecs/components/MaterialSpecRow/MaterialSpecRow";
import { MaterialSpecTableRowHeader } from "pages/MaterialSpecs/components";
import { MaterialSpecTypeMenu } from "pages/MaterialSpecs/components/MaterialSpecTypeMenu/MaterialSpecTypeMenu";
import { useMaterialSpecs } from "pages/MaterialSpecs/hooks";

export const MaterialSpecsTable = () => {
    const { defaultFilter } = useMaterialSpecs();
    const materialSpecifications = useSelector(getAllMaterialSpecifications);
    const lineItemHeader = useSelector(getLineItemsHeader);

    return (
        <TableContainer component={Paper} elevation={0} style={{ maxHeight: "100%" }}>
            <Table stickyHeader>
                <TableHead>
                    <MaterialSpecTableRowHeader>
                        {lineItemHeader.map((headerLabel) => {
                            return <TableCell key={headerLabel}>{headerLabel}</TableCell>;
                        })}
                        <TableCell />
                        <TableCell align="right">
                            <MaterialSpecTypeMenu />
                        </TableCell>
                    </MaterialSpecTableRowHeader>
                </TableHead>
                <TableBody>
                    {materialSpecifications
                        .filter(({ creativeType }) =>
                            defaultFilter.value ? creativeType === defaultFilter.name : true
                        )
                        .map((matSpec) => (
                            <MaterialSpecRow key={matSpec.id} row={matSpec} />
                        ))}
                </TableBody>
            </Table>
        </TableContainer>
    );
};
